// extracted by mini-css-extract-plugin
export default {"loginPage":"Login_loginPage__5V+cp","boo":"Login_boo__u8NCX"};